"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootTransactionsReducer = void 0;
var TransactionsReducer_1 = require("@/pages/common/reducers/TransactionsReducer");
exports.rootTransactionsReducer = {
    transactions: TransactionsReducer_1.transactionsReducer,
    otherTransactions: TransactionsReducer_1.otherTransactionsReducer,
};
